import OrderListViewStore from '@components/order/stores/OrderListViewStore';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderFoodList from './OrderFoodList';
import { Box } from '@mui/material';
import OrderInfo from './OrderInfo';
import BottomAction from './BottomAction';

interface OrderDetailsDrawerViewProps {
    orderListViewStore: OrderListViewStore;
}

const OrderDetailsDrawerView: React.FC<OrderDetailsDrawerViewProps> = observer(({ orderListViewStore }) => {
    const { orderRepeatContainer } = orderListViewStore;
    return (
        <>
            <Box
                flex={"1 1 auto"}
                sx={{
                    overflowY: "auto",
                    scrollbarWidth: "1px"
                }}>
                <OrderFoodList orderListViewStore={orderListViewStore} />
            </Box>

            <Box p={2} sx={{ boxShadow: "0 -1px 5px rgb(0 0 0 / 15%)", borderBottomLeftRadius: 16, borderBottomRightRadius: 16 }}>
                <OrderInfo orderListViewStore={orderListViewStore} />
                <BottomAction orderListViewStore={orderListViewStore} />
            </Box>
        </>
    )
})

export default OrderDetailsDrawerView;